import React from "react";

/**
 * "What happens after you get in touch."
 *
 * Baymard's abandonment data is B2C checkout, so the numbers do not transfer —
 * but the mechanism does: the largest design-attributable abandonment causes
 * are forced accounts, over-long flows and cost that only appears late. All
 * three are forms of "I don't know what I'm agreeing to". Stating the next
 * steps and when a price appears removes that uncertainty before the form,
 * not after it.
 */
const ProcessSteps = ({ steps = [] }) => {
  if (!steps.length) return null;

  return (
    <ol className="grid gap-8 md:grid-cols-3">
      {steps.map((step, i) => (
        <li key={step.title} className="relative">
          <span className="mb-4 flex h-10 w-10 items-center justify-center rounded-full border border-moss/60 font-serif text-lg text-moss-light">
            {i + 1}
          </span>
          <h3 className="mb-2 font-medium text-silver-light">{step.title}</h3>
          <p className="text-sm leading-relaxed text-silver-medium">{step.text}</p>
        </li>
      ))}
    </ol>
  );
};

export default ProcessSteps;
